import React, { Component } from 'react';
import {
    Container,
    Col,
    Row,
    Button,
    Table,
    Dropdown,
    DropdownToggle,
    DropdownMenu,
    DropdownItem,
    Input,
    Modal,
    ModalBody,
    ModalFooter
} from 'reactstrap';
import { StimaOrdine } from './StimaDeposito';
import { AddDeposito } from './AddDeposito';
import {Search} from '../Search'
import SelectCliente from '../Cliente/SelectCliente';



export class ContoDeposito extends Component {
    constructor(props) {
        super(props);
        
        this.state = {
            articoliCD: [],
            articolo: {},
            deleted: [],
            dropdownOpen: false,
            umSelected: 'PZ',
            articoloId: '',
            clienteModal: false,
            cliente:this.props.cliente? this.props.cliente : null,
            clienti: [],
            searchClienti: [],
            searchCodiceClienti: [],
            searchComplete: false ,
            searchCodiceComplete:false ,
            tipoOpzione : "Ritiro dal CD",
            indirrizoDropDownOpen: false,
            indirrizoDropDownText: this.props.luogoDiConsegna ? `${this.props.luogoDiConsegna.indirrizo1 ? this.props.luogoDiConsegna.indirrizo1 + " -" : ""} ${this.props.luogoDiConsegna.indirrizo2  ? this.props.luogoDiConsegna.indirrizo2 : ""} ${this.props.luogoDiConsegna.citta ? this.props.luogoDiConsegna.citta + "," : ""} ${this.props.luogoDiConsegna.provincia ? this.props.luogoDiConsegna.provincia : ""}  ${this.props.luogoDiConsegna.cap ? this.props.luogoDiConsegna.cap : ""}` : "Seleziona un indirizzo",
            indirrizoDropDownHeight: "",
            indirrizoId: this.props.luogoDiConsegna ? this.props.luogoDiConsegna.indirizzoId : "",
            articoloSelezionato: {},
            articolo:{},
            um: [],
            selectedUm: 'Seleziona UM',
            prezzo: '0',
            stima: 0,
            dataConsegna: "",
            ordineDataConsegna: this.props.ordineDataConsegna ? this.props.ordineDataConsegna : new Date().toISOString().split("T")[0],
            articoloQuantita: 1,
            sconto1: 0,
            sconto2: 0,
            note: '',
            articoli:[],
            errorModal: false,
            noteOrdine:'',
            errorIndirizzo: false,
            finalModal: false,
            checkboxChecked: false,
            costoTrasporto: 0,
            sogliaTrasporto: 0
        };

        console.log(this.props.codiceCliente);        
    }


    componentDidMount() {        
        
        if(!this.state.cliente){
            const form = {
                Informazione: "",
                CurrentRole: this.props.role
            };
    
            fetch(`../api/clienti/cerca`, {   
                method: 'POST',
                headers: new Headers({
                    //Authorization token
                    'Authorization': 'Bearer ' + sessionStorage.getItem("auth"),
                    //Sets the content type. Necessary for the server to recognize the information
                    'Content-Type': 'application/json' 
                }),
                //Sets the body of the call
                body: JSON.stringify(form)
                //Changes the response to an object
            }).then(response => response.json())
            .then(myjson => {
                this.setState({
                    clienti: myjson
                }, () => console.log(this.state.clienti))
    
            }).catch(e => {
    
            });
        }
        else{
            console.log(sessionStorage.getItem("selectedRole"))
            this.setState({
                articoli: this.state.articoli.map(
                    (articolo, ind) => {
                        return {
                            ...articolo, 
                            stimaSenzaSconto: this.calculateEstimate(articolo.prezzo, articolo.quantita, articolo.um, articolo.sconto1, articolo.sconto2, true), 
                            totalStima: this.calculateEstimateAfterSconti(articolo.prezzo, articolo.quantita, articolo.um, articolo.sconto1, articolo.sconto2, true),
                            pesoStimato: this.calculateWeight(articolo.um, articolo.prezzo, articolo.quantita)
                        }
                    }
                )
            }, () => {
                console.log(this.state.articoli)
            });
        }
    }
    toggle = () => {
        this.setState({

            dropdownOpen: !this.state.dropdownOpen
        })
    } 

    toggleErrorModal = () => {
        this.setState({
            errorModal: !this.state.errorModal
        })
    }

    handleOrdineDateChange = (e) => {
        this.setState({
            ordineDataConsegna: e.target.value
        })
    }
    
    toggleErrorIndirizzo =() =>{
        this.setState({
            errorIndirizzo: !this.state.errorIndirizzo
        })
    }
    
    handleNoteArticoloChange = (index, e) => {
        this.setState({
            articoli: this.state.articoli.map(
                (articolo, ind) => ind === index ? { ...articolo, note: e.target.value } : articolo),
        })
    }
    
    handleNoteOrdineChange = (e) => {
        this.setState({
            noteOrdine: e.target.value
        })
    }

    handleArticoloUmSelected = (um) =>
    {
        this.setState({
            umSelected: um,
            sconto1: this.state.prezzo.maxSconto1,
            sconto2: this.state.prezzo.maxSconto2
       }, () => {
               this.setState({
                     
               stima: this.calculateEstimateAfterSconti(this.state.prezzo, this.state.articoloQuantita, this.state.selectedUm, this.state.sconto1, this.state.sconto2, false)
           })            
       })
    }
    
    toggleStimaModal = () => {
        this.setState({
            stimaModal: !this.state.stimaModal,
            sconti: false,
            applicato40: false,
            applicato80: false
        })
     }
     
     toggleFinalModal = () => {
        this.setState({
            finalModal: !this.state.finalModal
        })
     }
    
     handleArticoloQuantitaChange = (num, index) => {
        console.log(num, index)
        if (this.state.umSelected == 'KG') {
            let articoli = [...this.state.articoli];
            let articolo = { ...articoli[index] };
            articolo.ritirato = articolo.ritirato + num            
            if (articolo.ritirato >= 0 && articolo.ritirato <= articolo.residuo1)
            {
                articoli[index] = articolo
                this.setState({
                    articoli: articoli,
                    articoloModal: false
                })
            }
            
        } else
        {
            let articoli = [...this.state.articoli];
            let articolo = { ...articoli[index] };
            articolo.ritirato = articolo.ritirato + num           
            if (articolo.ritirato >= 0 && articolo.ritirato <= articolo.residuo2) {                
                articoli[index] = articolo
                this.setState({
                    articoliDep: articoli
                })
            }
        }

    }

    
    handleArticoloselected = () =>
    {
        fetch(`/api/articoli/CD/${this.state.articoloSelezionato.articoloid}`, {
            method: 'GET',
            headers: new Headers({
                //Authorization token
                'Authorization': 'Bearer ' + sessionStorage.getItem("auth"),
                //Sets the content type. Necessary for the server to recognize the information
                'Content-Type': 'application/json'
            }),
            //Changes the response to an object
        }).then(response => response.json())
            .then(myjson => {
                if (myjson.statusCode) {
                    throw new Error("Not Found")
                }
                //this.props.caricaDeposito(myjson),
                this.setState({
                    articolo: myjson,
                    articoloErrore: false
                }, () => console.log('errore'))//this.state.articoli))

            }).catch(e => {
                this.setState({
                    articoloErrore: true
                })
            });
    }
    
    
    toggleClienteModal = () => {
        this.setState({
            clienteModal: !this.state.clienteModal
        })
    }

    clienteSelected = (cliente) => {
        console.log(cliente)
        if (cliente) {
            let codice = cliente.codiceCliente ? cliente.codiceCliente : cliente;
            
            fetch(`../api/clienti/${codice}`, {   
                method: 'GET',
                headers: new Headers({
                    //Authorization token
                    'Authorization': 'Bearer ' + sessionStorage.getItem("auth"),
                    //Sets the content type. Necessary for the server to recognize the information
                    'Content-Type': 'application/json' 
                }),
                //Changes the response to an object
            }).then(response => response.json())
            .then(myjson => {
                this.setState({
                    cliente: myjson,
                    clienteErrore: false
                }, () => {
                    console.log(this.state.cliente)
                    fetch(`/api/articoli/deposito/${codice}`, {
                        method: 'GET',
                        headers: new Headers({
                            //Authorization token
                            'Authorization': 'Bearer ' + sessionStorage.getItem("auth"),
                            //Sets the content type. Necessary for the server to recognize the information
                            'Content-Type': 'application/json'
                        }),
                        //Changes the response to an object
                    }).then(response => response.json())
                        .then(myjson => {
                            if (myjson.statusCode) {
                                throw new Error("Not Found")
                            }
                            //this.props.caricaDeposito(myjson),
                            this.setState({
                                articoliCD: myjson,
                                articoloErrore: false
                            }, () => console.log('errore'))//this.state.articoli))
            
                        }).catch(e => {
                            this.setState({
                                articoloErrore: true
                            })
                        });
                    if(cliente.codiceCliente){
                        this.toggleClienteModal();
                    }              
                })
            }).catch(e => {
                this.setState({
                    clienteErrore: true
                })
            });
            console.log(this.state.articoli)
        }
        else{
            this.toggleClienteModal();
        }
    }

    clienteSearch = (text) => {
        console.log(text);
        if(!text){
            this.setState({
                searchClienti: [],
                searchComplete: false
            })
        }
        else{
            const form = {
                Informazione: text,
                CurrentRole: sessionStorage.getItem("selectedRole")
            };
    
            fetch(`../api/clienti/cerca`, {   
                method: 'POST',
                headers: new Headers({
                    //Authorization token
                    'Authorization': 'Bearer ' + sessionStorage.getItem("auth"),
                    //Sets the content type. Necessary for the server to recognize the information
                    'Content-Type': 'application/json' 
                }),
                //Sets the body of the call
                body: JSON.stringify(form)
                //Changes the response to an object
            }).then(response => response.json())
            .then(myjson => {
                this.setState({
                    searchClienti: myjson,
                    searchComplete: true,
                })
            }).catch(e => {
                
            });
        }
    } 

    clienteCodiceSearch = (text) => {
        console.log(text);
        if(!text){
            this.setState({
                searchCodiceClienti: [],
                searchCodiceComplete: false
            })
        }
        else{
            const form = {
                Informazione: text,
                CurrentRole: sessionStorage.getItem("selectedRole")
            };
            console.log(form)
            fetch(`../api/clienti/cercaCodice`, {   
                method: 'POST',
                headers: new Headers({
                    //Authorization token
                    'Authorization': 'Bearer ' + sessionStorage.getItem("auth"),
                    //Sets the content type. Necessary for the server to recognize the information
                    'Content-Type': 'application/json' 
                }),
                //Sets the body of the call
                body: JSON.stringify(form)
                //Changes the response to an object
            }).then(response => response.json())
            .then(myjson => {
                this.setState({
                    searchCodiceClienti: myjson,
                    searchCodiceComplete: true,
                })
    
            }).catch(e => {
    
            });
        }
    } 

    toggleArticoloModal = () => {
            this.setState({
                articoloModal: !this.state.articoloModal
            })
        }

    

    toggleIndirrizoDropDown = () => {
        
        if(this.state.indirrizoDropDownOpen){
            this.setState({
                indirrizoDropDownHeight: "",
                indirrizoDropDownOpen: !this.state.indirrizoDropDownOpen
            })
        }
        else{
            this.setState({
                indirrizoDropDownHeight: "30vh",
                indirrizoDropDownOpen: !this.state.indirrizoDropDownOpen
            })
        }
    }
    
    handleIndirrizoSelected = (indirrizo) => {
        this.setState({
            indirrizoId: indirrizo.indirizzoId,
            indirrizoDropDownText: `${indirrizo.indirizzo1 ? indirrizo.indirizzo1 + " -" : ""} ${indirrizo.indirizzo2  ? indirrizo.indirizzo2 : ""} ${indirrizo.citta ? indirrizo.citta + "," : ""} ${indirrizo.provincia ? indirrizo.provincia : ""}  ${indirrizo.cap ? indirrizo.cap : ""}`,
        })
    }

    handleCodiceSearchChange = (e) => {
        this.setState({
            codiceText: e.target.value,
        })
    }

    handleCodiceSearchSubmit = (e) => {
        e.preventDefault();
  
        
        this.clienteSelected(this.state.codiceText)
    }

    SelezionaArticolo = (articolo) => {
        
        this.setState({
            articoloSelezionato : articolo
        })
        
        fetch(`/api/articoli/CD/${articolo.articoloid}`, {   
            method: 'GET',
            headers: new Headers({
                //Authorization token
                'Authorization': 'Bearer ' + sessionStorage.getItem("auth"),
                //Sets the content type. Necessary for the server to recognize the information
                'Content-Type': 'application/json' 
            }),
            //Changes the response to an object
        }).then(response => response.json())
        .then(myjson => {
            if(myjson.statusCode){
                throw new Error("Not Found")
            }
            this.setState({
                articolo: myjson,
                articoloErrore: false
            }, () => console.log(this.state.articolo))

        }).catch(e => {
            this.setState({
                articoloErrore: true
            })
        });
        
        fetch(`/api/articoli/um`, {   
            method: 'GET',
            headers: new Headers({
                //Authorization token
                'Authorization': 'Bearer ' + sessionStorage.getItem("auth"),
                //Sets the content type. Necessary for the server to recognize the information
                'Content-Type': 'application/json' 
            }),
            //Changes the response to an object
        }).then(response => response.json())
        .then(myjson => {
            this.setState({
                um: myjson,
            }, () => console.log(this.state.um))

        }).catch(e => {

        });
        fetch(`/api/cliente/${this.state.cliente.codiceCliente}/articoli/${articolo.articoloid}/prezzo`, {   
            method: 'GET',
            headers: new Headers({
                //Authorization token
                'Authorization': 'Bearer ' + sessionStorage.getItem("auth"),
                //Sets the content type. Necessary for the server to recognize the information
                'Content-Type': 'application/json' 
            }),
            //Changes the response to an object
        }).then(response => response.json())
        .then(myjson => {
            if(myjson.statusCode){
                throw new Error("Not Found")
            }
            this.setState({
                prezzo: myjson,
            }, () => console.log(this.state.prezzo))

        }).catch(e => {
            this.setState({
                articoloErrore: true
            })
        });

        this.toggleArticoloModal();
    }
    
    handleArticoloUmSelected = (text) => {
        let quantita = this.state.articoloQuantita; 
        let selezionato = this.state.articoloSelezionato; 
       
        if(text == "PZ")
        {
            if(quantita > selezionato.residuo2)
            {
                quantita = selezionato.residuo2
                this.setState({
                    
                    articoloQuantita: quantita
                    
                })
            }
        }
        
        this.setState({
            selectedUm: text,
             sconto1: this.state.prezzo.maxSconto1,
             sconto2: this.state.prezzo.maxSconto2
        }, () => {
                this.setState({
                stima: this.calculateEstimateAfterSconti(this.state.prezzo, this.state.articoloQuantita, this.state.selectedUm, this.state.sconto1, this.state.sconto2, false)
            })            
        })
    }
    
    calculateEstimate = (prezzo, articoloQuantita, selectedUm, isEdit) => {
        
        if(!isEdit && selectedUm === 'Seleziona UM'){
            console.log("got here")
            return 0;
        }
        else{
            let stimaSenzaSconto = 0;

            if(selectedUm === 'KG'){
                if(prezzo.um === 'KG'){
                    stimaSenzaSconto = prezzo.prezzo * articoloQuantita; 
                }
                else if(prezzo.um === 'PZ'){   
                    stimaSenzaSconto = (prezzo.peso * articoloQuantita) * prezzo.prezzo;
                }
            }
            else if(selectedUm === 'PZ'){
                if(prezzo.um === 'KG'){
                    
                    stimaSenzaSconto = (prezzo.prezzo * prezzo.peso) * articoloQuantita;
                }
                else if(prezzo.um === 'PZ'){
                    stimaSenzaSconto = prezzo.prezzo * articoloQuantita;
                }
            }
            else if(selectedUm === 'MT'){
                if(prezzo.um === 'KG'){
                    stimaSenzaSconto = (prezzo.prezzo /prezzo.peso) * articoloQuantita;
                }
                else if(prezzo.um === 'PZ'){
                    stimaSenzaSconto = prezzo.prezzo * articoloQuantita * prezzo.cartonaggio;
                }
                else if(prezzo.um === 'MT'){
                    stimaSenzaSconto = prezzo.prezzo * articoloQuantita;
                }
            }
            else{
                if(prezzo.um === 'KG'){
                    stimaSenzaSconto = (prezzo.prezzo / prezzo.peso) * articoloQuantita;
                }
                else if(prezzo.um === 'PZ'){
                    stimaSenzaSconto = prezzo.prezzo;
                }
            }

            return stimaSenzaSconto;
        }        
    }
    
    handleDelete = (articolo, index) => {

        const temp = this.state.articoli;
        const deleted = this.state.deleted;
        
        temp.splice(index, 1).forEach(element => {
            deleted.push(element);
        });
        this.setState({
            articoli: temp,
            deleted: deleted
        })
    }

    calculateEstimateAfterSconti = (prezzo, articoloQuantita, selectedUm, sconto1, sconto2, isEdit) => {
        let totalStima = this.calculateEstimate(prezzo, articoloQuantita, selectedUm, isEdit);
    
            if(sconto1 !== 0){
                totalStima -= this.calculateSconto1(sconto1, totalStima)
            }
    
            if(sconto2 !== 0){
                totalStima -= this.calculateSconto2(sconto2, totalStima)
            }

            return totalStima;
    }

    calculateWeight = (selectedUm, prezzo, quantita) => {
        if(selectedUm === 'KG'){
            return quantita;
        }
        else if(selectedUm === 'PZ'){
            return quantita * prezzo.peso
        }
    }
    
    calculateSconto1 = (sconto1, startVal) => {
        return (startVal * ((sconto1*1.0)/100));
    }

    calculateSconto2 = (sconto2, startVal) => {
        return (startVal * ((sconto2*1.0)/100));
    }
    
    calculateWeight = (selectedUm, prezzo, quantita) => {
        if(selectedUm === 'KG'){
            return quantita;
        }
        else if(selectedUm === 'PZ'){
            return quantita * prezzo.peso
        }
    }

    handleInserisciClick = () => {
        let stimaSenzaSconto = this.calculateEstimate(this.state.prezzo, this.state.articoloQuantita, this.state.selectedUm, this.state.sconto1, this.state.sconto2, false);

        let totalStima = stimaSenzaSconto;

        let minSconto1 = 0;

        if(this.state.sconto1 !== 0){
            minSconto1 = this.calculateSconto1(this.state.sconto1, totalStima)

            totalStima -= minSconto1;
        }

        let minSconto2 = 0;

        if(this.state.sconto2 !== 0){
            minSconto2 = this.calculateSconto2(this.state.sconto2, totalStima)

            totalStima -= minSconto2;
        }
        
        const tempArticolo = {
            articoloId: this.state.articolo.articoloId,
            descrizione: this.state.articolo.descrizione,
            articoloUm: this.state.prezzo.um,
            quantita: this.state.articoloQuantita,
            um: this.state.selectedUm,
            prezzo: this.state.prezzo,
            sconto1: this.state.sconto1,
            sconto2: this.state.sconto2,
            dataConsegna: this.state.dataConsegna !== "" ? this.state.dataConsegna : this.state.ordineDataConsegna,
            note: this.state.note,
            stimaSenzaSconto: stimaSenzaSconto,
            stimaConSconto1: minSconto1,
            stimaConSconto2: minSconto2,
            totalStima: totalStima,
            tipoOpzione: this.state.tipoOpzioneId,
            pesoStimato: this.calculateWeight(this.state.selectedUm, this.state.prezzo, this.state.articoloQuantita)
        }
        console.log(tempArticolo);
        
        const tempArticoli = this.state.articoli;
        tempArticoli.push(tempArticolo)

        this.setState({
            articoli: tempArticoli           
        })

        this.toggleArticoloModal();

    }

    handleArticoloQuantitaChange = (num) => {
        let quantita = this.state.articoloQuantita;
        let selezionato = this.state.articoloSelezionato;
        let Um = this.state.selectedUm;
        let articolo = this.state.articolo; 

        if(Um == "Seleziona UM")
        {
            this.toggleErrorModal(); 
        }else
        {
            if(Um == 'PZ')
            {
               
                if(quantita + num >0 && quantita + num <= selezionato.residuo2){    
                    this.setState({
                        articoloQuantita: this.state.articoloQuantita + num,
                    }, () => {
                        this.setState({
                            stima: this.calculateEstimateAfterSconti(this.state.prezzo, this.state.articoloQuantita, this.state.selectedUm, this.state.sconto1, this.state.sconto2, false)
                        })
                })
            }
            }else
            {
                if(quantita + num >0 && quantita + num <= selezionato.residuo1){    
                    this.setState({
                            articoloQuantita: this.state.articoloQuantita + num,
                        }, () => {
                            this.setState({
                                stima: this.calculateEstimateAfterSconti(this.state.prezzo, this.state.articoloQuantita, this.state.selectedUm, this.state.sconto1, this.state.sconto2, false)
                            })
                        })
                    }
            }
        }
    }

    toggleAddArticoloModal = () => {
        this.setState({
            addArticoloModal: !this.state.addArticoloModal,
            sconti: false
        })
    }
    handleDateChange = (e) => {
        this.setState({
            dataConsegna: e.target.value
        })
    }
    
    handleNoteChange = (e) => {
        this.setState({
            note: e.target.value
        })
    }

    handleGoToStima = () => {
        
        let indirizzo = this.state.indirrizoId;
        if(indirizzo == '')
        {
            this.toggleErrorIndirizzo();
        }else
        {

            let tempStima = 0;
            let tempSconto1 = 0;
            let tempSconto2 = 0;
            let temptotale = 0;
            let tempTotalQta = 0;
        
        this.state.articoli.forEach(articolo => {
            tempStima += articolo.stimaSenzaSconto;
            tempSconto1 += articolo.stimaConSconto1;
            tempSconto2 += articolo.stimaConSconto2;
            temptotale += articolo.totalStima;
            tempTotalQta += articolo.pesoStimato;
        });
        
       
        
        /*    if (tempTotalQta >= 40 && tempTotalQta < 80 && this.state.cliente.anagraficaListiniId == 'LE') {
                this.calcolaSconto40();               
                this.setState({
                avanzateBtn: true,
                sconto40Btn: true,
                sconto80Btn: false,
                
            })
            console.log("avanzate:"+this.state.avanzateBtn)
            }else if (tempTotalQta >= 80 && this.state.cliente.anagraficaListiniId == 'LE') {
                this.calcolaSconto40()
                this.calcolaSconto80();
                this.setState({                   
                    avanzateBtn: true,
                    sconto40Btn: true,
                    sconto80Btn: true
                })
            } else
            {*/
                this.setState({
                    avanzateBtn: false,
                    sconto40Btn: false,
                    sconto80Btn: false
                })              
            //}
            
            this.setState({
                totalStima: tempStima,
                minSconto1: tempSconto1,
                minSconto2: tempSconto2,
                totalStimaAfterSconti: tempStima,
                totalQta: tempTotalQta
            }, () => this.toggleStimaModal())
            
        }
    }

    handleCompleteOrder = () => {
        var nuovoPrezzo;
        nuovoPrezzo = this.state.checkboxChecked == true && this.state.prezzo <= this.state.sogliaTrasporto ? this.state.prezzo + this.state.costoTrasporto : this.state.prezzo;
        this.setState({ prezzo: nuovoPrezzo });
        console.log("Il prezzo è " + this.state.prezzo);

        const form = {
            codiceCliente: this.state.cliente.codiceCliente,
            articoli: this.state.articoli,
            posizione: this.state.cliente.posizione,
            listino: this.state.cliente.AnagraficaListiniId,
            luogoDiConsegna: this.state.indirrizoId,
            tipoOpzione: 3,
            dataConsegna: this.state.ordineDataConsegna,
            noteOrdine: this.state.noteOrdine,
            applicato40: this.state.applicato40,
            applicato80: this.state.applicato80,
            articoli40: this.state.articoli40,
            articoli80: this.state.articoli80,
            checkCostoTrasporto: this.state.checkboxChecked
        };
            console.log(form.applicato40);
            
            let url = `/api/ordini/add`;

            if (this.props.isControllo) {
                url = `/api/ordini/update/controller`;
                form.ordineId = this.props.ordineId;
                form.deleted = this.state.deleted;
                form.note = this.props.note;

            }
            else if (this.props.status) {
                url = `/api/ordini/update`;
                form.ordineId = this.props.ordineId;
                form.deleted = this.state.deleted;
                form.note = this.props.note;
            }

            fetch(url, {
                method: 'POST',
                headers: new Headers({
                    //Authorization token
                    'Authorization': 'Bearer ' + sessionStorage.getItem("auth"),
                    //Sets the content type. Necessary for the server to recognize the information
                    'Content-Type': 'application/json'
                }),
                //Sets the body of the call
                body: JSON.stringify(form)
                //Changes the response to an object
            }).then(response => {
                if (response.status === 200) {
                    if (this.props.isControllo || this.props.status) {
                        this.props.history.push('/ContoDeposito');
                    }
                    else {
                        this.toggleFinalModal()
                    }
                    
                }
            }).catch(e => {
                
            });
            
            this.setState({
                disabilita: true
            })
        
        
    }

    handleChange = (value, costo, soglia) => {
        this.setState({
            checkboxChecked: value,
            costoTrasporto: costo,
            sogliaTrasporto: soglia
        });
    }
    
    
    render() {
        return (
            <Container>
                <Container className="d-flex align-items-center" fluid>
                    <Row className="d-flex justify-content-center align-items-center" style={{ width: "100vw", margin: "0px", padding: "0px" }}>
                        <Col className="d-flex align-items-center justify-content-center" style={{ width: "100%", margin: "0px", padding: "0px" }}>
                            Ritiro Conto Deposito
                        </Col>
                    </Row>
                </Container>                
                <Container className="d-flex align-items-center" fluid>
                    <Row className="d-flex justify-content-center align-items-center" style={{ width: "100vw", margin: "0px", padding: "0px" }}>
                        <Col className="d-flex align-items-center justify-content-center" style={{ width: "100%", margin: "0px", padding: "0px", paddingTop: "5px", paddingBottom: "5px", marginTop: "10px" }}>
                            <Table responsive borderless style={{ width: "75%", margin: "0", marginTop: "5px" }}>
                                <tbody style={{ fontSize: "20px" }}>
                                    <tr>
                                        <th style={{ width: "25%", padding: "5px", paddingRight: "20px", textAlign: "right" }}>Cliente:  </th>
                                        <td align="left" style={{ padding: "5px", height: `${this.state.clientiHeight}` }}>
                                            <div>
                                                {this.state.cliente ?
                                                    <div>
                                                        {`${this.state.cliente.codiceCliente} - ${this.state.cliente.ragSoc}`}
                                                    </div> :
                                                    <div>
                                                        <div style={{ float: "left", marginRight: "10px" }}>
                                                            <Button className="text-center" style={{ padding: "10px", paddingTop: "5px", paddingBottom: "5px", backgroundColor: "#011e41", fontSize: "20px" }} onClick={this.toggleClienteModal}>
                                                                Seleziona un cliente
                                                            </Button>
                                                        </div>
                                                        <div style={{ float: "left" }}>
                                                            o
                                                            </div>
                                                        <div style={{ float: "left", marginLeft: "25px" }}>
                                                            <Search placeholder={`Inserisci codice cliente`} handleSearchChange={this.handleCodiceSearchChange} handleSearchSubmit={this.handleCodiceSearchSubmit} />
                                                        </div>
                                                    </div>

                                                }
                                            </div>
                                        </td>
                                    </tr>
                                    {this.state.clienteErrore ?
                                        <tr>
                                            <th style={{ width: "25%", padding: "5px", paddingRight: "20px", textAlign: "right" }}></th>
                                            <td align="left" style={{ padding: "5px", color: "red" }}>
                                                Cliente non esiste. Controlla codice e riprova.
                                            </td>
                                        </tr> : null
                                    }
                                    {this.state.cliente ?
                                        <tr>
                                            <th style={{ width: "25%", padding: "5px", paddingRight: "20px", textAlign: "right", height: `${this.state.indirrizoDropDownHeight}` }}>Luogo di Consegna:  </th>
                                            <td align="left" style={{ padding: "5px" }}>
                                                {this.props.luogoDiConsegna && this.props.status === "Presi In Carico" ?
                                                    <div>
                                                        {`${this.props.luogoDiConsegna.indirrizo1 ? this.props.luogoDiConsegna.indirrizo1 + " -" : ""} ${this.props.luogoDiConsegna.indirrizo2 ? this.props.luogoDiConsegna.indirrizo2 : ""} ${this.props.luogoDiConsegna.citta ? this.props.luogoDiConsegna.citta + "," : ""} ${this.props.luogoDiConsegna.provincia ? this.props.luogoDiConsegna.provincia : ""}  ${this.props.luogoDiConsegna.cap ? this.props.luogoDiConsegna.cap : ""}`}
                                                    </div> :
                                                    <Dropdown isOpen={this.state.indirrizoDropDownOpen} toggle={this.toggleIndirrizoDropDown}>
                                                        <DropdownToggle style={{ backgroundColor: "#011e41", paddingTop: "2px", paddingBottom: "2px", fontSize: "20px" }} caret>
                                                            {this.state.indirrizoDropDownText}
                                                        </DropdownToggle>
                                                        <DropdownMenu
                                                            modifiers={{
                                                                setMaxHeight: {
                                                                    enabled: true,
                                                                    order: 890,
                                                                    fn: (data) => {
                                                                        return {
                                                                            ...data,
                                                                            styles: {
                                                                                ...data.styles,
                                                                                overflow: 'auto',
                                                                                maxHeight: "25vh",
                                                                            },
                                                                        };
                                                                    },
                                                                },
                                                                computeStyle: {
                                                                    gpuAcceleration: false
                                                                }
                                                            }}>
                                                            {   //Creates an item in the dropdown list for each item from the call to the server
                                                                this.state.cliente.luogoDiConsegna.map(indirrizo =>
                                                                    <DropdownItem
                                                                        key={indirrizo.indirizzoId}
                                                                        onClick={() => this.handleIndirrizoSelected(indirrizo)}>
                                                                        {`${indirrizo.indirizzo1 ? indirrizo.indirizzo1 + " -" : ""} ${indirrizo.indirizzo2 ? indirrizo.indirizzo2 : ""} ${indirrizo.citta ? indirrizo.citta + "," : ""} ${indirrizo.provincia ? indirrizo.provincia : ""}  ${indirrizo.cap ? indirrizo.cap : ""}`}
                                                                    </DropdownItem>)
                                                            }
                                                        </DropdownMenu>
                                                    </Dropdown>

                                                }
                                            </td>
                                        </tr> : null
                                    }
                                    {this.state.cliente ?
                                        <tr>
                                            <th style={{ width: "25%", padding: "5px", paddingRight: "20px", textAlign: "right", height: `${this.state.tipoOpzioneHeight}` }}>Tipo di Opzione:  </th>
                                            <td align="left" style={{ padding: "5px" }}>{this.state.tipoOpzione}</td>
                                        </tr> : null
                                    }
                                    {this.state.cliente && this.props.opzione && this.props.status === "Presi In Carico" ?
                                        <tr>
                                            <th style={{ width: "50%", padding: "0", paddingRight: "20px", textAlign: "right" }}>Data di Consegna:  </th>
                                            <td align="left" style={{ padding: "5px" }}>
                                                <div>
                                                    {new Date(this.props.ordineDataConsegna).toLocaleDateString()}
                                                </div>
                                            </td>
                                        </tr> : this.state.cliente && this.props.opzione && this.props.status === "In Attesa" ?
                                            <tr>
                                                <th style={{ width: "50%", padding: "0", paddingRight: "20px", textAlign: "right" }}>Data di Consegna:  </th>
                                                <td align="left" style={{ padding: "5px" }}>
                                                    <div>
                                                        <Input type="date" name="dataDiConsegna" id="dataDiConsegna" style={{ height: "100%", width: "100%", fontSize: "20px", padding: "0", paddingLeft: "5px" }} onChange={this.handleOrdineDateChange} value={this.state.ordineDataConsegna} />
                                                    </div>
                                                </td>
                                            </tr> : null

                                    }
                                </tbody>
                            </Table>
                        </Col>
                    </Row>
                </Container>
                {this.state.cliente?
                    this.state.articoliCD != ""?
                    <Container>
                    <Container className="d-flex align-items-center" fluid>
                    <Row className="d-flex justify-content-center align-items-center" style={{ width: "100vw", margin: "0px", padding: "0px" , borderTop: "1px solid #011e41"}}>
                    <Col className="d-flex align-items-center justify-content-center" style={{ width: "100%", margin: "0px", padding: "0px", paddingTop: "5px", paddingBottom: "5px", marginTop: "10px" }}>
                                    <Table responsive borderless style={{ margin: "0", marginTop: "5px", fontSize: "20px" }}>
                                        <thead>
                                            <tr>
                                                <th style={{ padding: "0", width: "7%", textAlign: "center" }}>Articolo Id</th>
                                                <th style={{ padding: "0", width: "18%", textAlign: "center" }}>Descrizione</th>
                                                <th style={{ padding: "0", width: "12%", textAlign: "center" }}>KG Residui</th>
                                                <th style={{ padding: "0", width: "12%", textAlign: "center" }}>PZ Residui</th>
                                                <th style={{ padding: "0", width: "12%", textAlign: "center" }}></th>                   
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {this.state.articoliCD.map((articolo, index) => {
                                                return (
                                                        <tr key={index}>                                            
                                                            <td align="center" style={{ padding: "0", width: "7%" }}>{articolo.articoloid}</td>
                                                            <td align="center" style={{ padding: "0", width: "18%" }}>{articolo.articolo.descrizione}</td>
                                                            <td align="center" style={{ padding: "0", width: "12%" }}>{articolo.residuo1} {articolo.um1}</td>                                             
                                                            <td align="center" style={{ padding: "0", width: "12%" }}>{articolo.residuo2} {articolo.um2}</td>
                                                            <td>
                                                                    <Button type="button" className="text-center" onClick={() => this.SelezionaArticolo(articolo)} style={{ width: '50%', padding: '0px', backgroundColor: "#011e41", fontSize: "20px" }}>
                                                                        Aggiungi
                                                                    </Button>
                                                            </td>
                                                        </tr>
                                                )
                                            })}
                                        </tbody>                             
                                    </Table>
                                </Col>
                            </Row>
                        </Container> 
                    </Container>:
                    
                    <Container className="d-flex align-items-center" fluid>
                        <Row className="d-flex justify-content-center align-items-center" style={{ width: "100vw", margin: "0px", padding: "0px" }}>
                            <Col className="d-flex align-items-center justify-content-center" style={{ width: "100%", margin: "0px", padding: "0px", paddingTop: "5px", paddingBottom: "5px", marginTop: "10px" }}>
                                <h5 style={{ color: "#011e41", fontWeight: "bold", margin: "0px" }}>NESSUN PRODOTTO IN CONTO DEPOSITO</h5>
                            </Col>
                        </Row>
                    </Container>
                : null
                }
                 {this.state.articoli !=""?
                 <div>  
                     <Container className="d-flex align-items-center" fluid>
                            <Row className="d-flex justify-content-center align-items-center" style={{ width: "100vw", margin: "0px", padding: "0px", borderTop: "1px solid #011e41"}}>                                
                                <Col className="d-flex align-items-center justify-content-center" style={{ width: "100%", margin: "0px", padding: "0px", paddingTop: "5px", paddingBottom: "5px", marginTop: "10px" }}>
                                    <Table responsive borderless style={{ margin: "0", marginTop: "5px", fontSize: "20px" }}>
                                        <thead>
                                            <tr>
                                                <th style={{ padding: "0", width: "5%", textAlign: "center" }}></th>
                                                <th style={{ padding: "0", width: "7%", textAlign: "center" }}>Articolo Id</th>
                                                <th style={{ padding: "0", width: "18%", textAlign: "center" }}>Descrizione</th>
                                                <th style={{ padding: "0", width: "12%", textAlign: "center" }}>Quantità</th>
                                                <th style={{ padding: "0", width: "7%", textAlign: "center" }}>Peso Stimato</th>
                                                <th style={{ padding: "0", width: "7%", textAlign: "center" }}>Data di Consegna</th>
                                                <th style={{ padding: "0", width: "18%", textAlign: "center" }}>Note</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {this.state.articoli.map((articolo, index) => {
                                                return (
                                                    <tr key={index}>
                                                        <td align="center" style={{ padding: "0", width: "5%" }}>
                                                            {!this.props.isReview || this.props.status !== "Presi In Carico" ?
                                                                <Button type="submit"
                                                                    onClick={() => this.handleDelete(articolo, index)}
                                                                    style={{
                                                                        width: "10%",
                                                                        padding: "0px",
                                                                        color: "#011e41",
                                                                        border: "none",
                                                                        backgroundColor: "transparent",
                                                                        marginLeft: "5px",
                                                                        marginRight: "10px"
                                                                    }}
                                                                >
                                                                    <i className="fa fa-trash" aria-hidden="true"></i>
                                                                </Button> : null
                                                            }
                                                        </td>
                                                        <td align="center" style={{ padding: "0", width: "7%" }}>{articolo.articoloId}</td>
                                                        <td align="center" style={{ padding: "0", width: "18%" }}>{articolo.descrizione}</td>
                                                        <td align="center" style={{ padding: "0", width: "12%" }}>
                                                            {this.props.status == "Presi In Carico" ?
                                                                <div>
                                                                    {articolo.quantita}/{articolo.um}
                                                                </div> :
                                                                <div>
                                                                    {articolo.quantita} {articolo.um}
                                                                </div>
                                                            }
                                                        </td>
                                                        <td align="center" style={{ padding: "0", width: "7%" }}>{parseFloat(articolo.pesoStimato).toFixed(2)} kg {articolo.um !== articolo.prezzo.um ? '*' : null}</td>
                                                        <td align="center" style={{ padding: "0", width: "7%" }}>{new Date(articolo.dataConsegna).toLocaleDateString()}</td>
                                                        <td align="center" style={{ padding: "0", width: "18%" }}>{this.props.status == "Presi In Carico" ?
                                                            <div>
                                                                {articolo.note}
                                                            </div> :
                                                            <div>
                                                                <Input type="textarea" id="note" name="note" style={{ height: "100%", width: "100%", fontSize: "20px", padding: "0", paddingLeft: "5px" }} onChange={(e) => this.handleNoteArticoloChange(index, e)} value={articolo.note} />
                                                            </div>
                                                        }
                                                        </td>
                                                    </tr>
                                                )
                                            })}
                                        </tbody>
                                    </Table>
                                </Col>
                            </Row>
                        </Container>
                    </div> : null
                }
                <Container className="d-flex align-items-center" fluid>
                            <Row className="d-flex justify-content-center align-items-center" style={{width: "100vw", margin: "0px", padding: "0px", borderTop: "1px solid #011e41"}}>
                                <Col className="d-flex align-items-center justify-content-center" style={{width: "100%", margin: "0px", padding: "0px", paddingTop: "5px", paddingBottom: "5px", marginTop: "10px"}}>
                                    {this.props.isReview && this.props.status === "Presi In Carico" ? 
                                        null :
                                        <Row style={{width: "100%", margin: "0px", padding: "0px"}}>
                                                {this.props.isControllo || this.props.status ? 
                                                <Col>
                                                    <Row className="d-flex align-items-center justify-content-start" style={{width: "100%", margin: "0px", padding: "0px"}}>
                                                        {this.props.children}
                                                    </Row>
                                                    <Row className="d-flex align-items-center justify-content-center" style={{width: "100%", margin: "0px", padding: "0px"}}>
                                                        <Button type="button" className="text-center" onClick={this.props.toggleOrdineModal} style={{width: '30%', padding: '0px', marginRight:"10px", backgroundColor: "#011e41", fontSize: "20px"}}>                                    
                                                                Annulla
                                                            </Button>
                                                            {this.state.cliente && this.state.articoli.length > 0 ? 
                                                               <Button type="button" className="text-center" onClick={this.handleGoToStima} style={{width: '30%', padding: '0px', marginLeft:"10px", backgroundColor: "#011e41", fontSize: "20px"}}>                                    
                                                                Modifica
                                                               </Button> : null 
                                                            } 
                                                    </Row>
                                                </Col>
                                            : 
                                                <Col className="d-flex align-items-center justify-content-center" style={{width: "100%", margin: "0px", padding: "0px"}}>
                                                    <Button type="button" className="text-center" onClick={() => this.props.history.push('/nuovoOrdine')} style={{width: '30%', padding: '0px', marginRight:"10px", backgroundColor: "#011e41", fontSize: "20px"}}>                                    
                                                        Annulla
                                                    </Button>
                                                    {this.state.cliente && this.state.articoliCD.length > 0  ? 
                                                        <Button type="button" className="text-center" onClick={this.handleGoToStima} style={{width: '30%', padding: '0px', marginLeft:"10px", backgroundColor: "#011e41", fontSize: "20px"}}>                                    
                                                         Vai avanti
                                                        </Button> : null 
                                                    }    
                                                </Col>
                                            }
                                        </Row>
                                    }                               
                                </Col>
                            </Row> 
                    </Container>

                <Modal size="md" isOpen={this.state.clienteModal} toggle={this.toggleClienteModal} style={{color: "#011e41"}}>
                    <ModalBody>
                        <Container className="d-flex justify-content-center align-items-center" fluid>
                            <SelectCliente 
                                clienti={this.state.clienti}
                                searchClienti={this.state.searchClienti}
                                searchCodiceClienti={this.state.searchCodiceClienti}
                                searchComplete={this.state.searchComplete}
                                searchCodiceComplete={this.state.searchCodiceComplete}
                                clienteSelected={this.clienteSelected}
                                clienteSearch={this.clienteSearch}
                                clienteCodiceSearch={this.clienteCodiceSearch}
                            />
                        </Container>
                    </ModalBody>
                </Modal>
                <Modal size="xl" isOpen={this.state.articoloModal} toggle={this.toggleArticoloModal} style={{ color: "#011e41" }}>
                    <ModalBody>
                        {this.state.cliente ?
                            <Container className="d-flex align-items-center" style={{ width: "100%" }} fluid>
                                <Row className="d-flex justify-content-center align-items-center" style={{ width: "100%", margin: "0px", padding: "0px" }}>
                                    <Col className="d-flex align-items-center justify-content-center" style={{ width: "100%", margin: "0px", padding: "0px", paddingTop: "5px", paddingBottom: "5px", marginTop: "10px" }}>
                                        <div>
                                            <h4 style={{ color: "#011e41", fontWeight: "bold", margin: "0px" }}>{`${this.state.cliente.codiceCliente} - ${this.state.cliente.ragSoc}`}</h4>
                                        </div>
                                    </Col>
                                </Row>
                            </Container> : null
                        }
                        <Container className="d-flex justify-content-center align-items-center" fluid>
                            <AddDeposito
                                articoloSelezionato={this.state.articoloSelezionato}
                                articolo = {this.state.articolo}
                                um={this.state.um}
                                selectedUm={this.state.selectedUm}
                                quantita={this.state.articoloQuantita}
                                prezzo={this.state.prezzo}
                                sconto1={this.state.sconto1}
                                sconto2={this.state.sconto2}
                                stima={this.state.stima}
                                dataConsegna={this.state.dataConsegna}
                                dataDisabled={!this.props.isReview}
                                note={this.state.note}
                                toggleAddArticoloModal={this.toggleAddArticoloModal}
                                handleArticoloUmSelected={this.handleArticoloUmSelected}
                                handleArticoloQuantitaChange={this.handleArticoloQuantitaChange}
                                handleDateChange={this.handleDateChange}
                                handleNoteChange={this.handleNoteChange}
                                handleInserisciClick={this.handleInserisciClick}
                                articoloErrore={this.state.articoloErrore}
                                articoloId={this.state.articoloId}
                                handleCodiceArticoloClick={this.props.handleCodiceArticoloClick}
                                handleArticoloselected = {this.handleArticoloselected}
                                
                            />
                        </Container>
                    </ModalBody>
                </Modal>
                <Modal size="md" isOpen={this.state.stimaModal} toggle={this.toggleStimaModal} style={{color: "#011e41"}}>
                    <ModalBody>
                        {this.state.cliente ? 
                            <Container className="d-flex align-items-center" style={{width: "100%"}} fluid>
                                <Row className="d-flex justify-content-center align-items-center" style={{width: "100%", margin: "0px", padding: "0px"}}>
                                    <Col className="d-flex align-items-center justify-content-center" style={{width: "100%", margin: "0px", padding: "0px", paddingTop: "5px", paddingBottom: "5px", marginTop: "10px"}}>
                                        <div>
                                            <h4 style={{color: "#011e41", fontWeight: "bold", margin: "0px"}}>{`${this.state.cliente.codiceCliente} - ${this.state.cliente.ragSoc}`}</h4>
                                        </div>                             
                                    </Col>
                                </Row> 
                            </Container> : null
                        }
                        <Container className="d-flex align-items-center" fluid>
                            <Row className="d-flex justify-content-center align-items-center" style={{width: "100vw", margin: "0px", padding: "0px"}}>
                                <Col className="d-flex align-items-center justify-content-center" style={{width: "100%", margin: "0px", padding: "0px", paddingTop: "5px", paddingBottom: "5px", marginTop: "10px"}}>
                                    <StimaOrdine
                                        checkboxChecked={this.state.checkboxChecked}
                                        handleChange={this.handleChange}
                                        totalStima={this.state.totalStima}
                                        sconto40={this.state.sconto40Tot}
                                        sconto80={this.state.sconto80Tot}
                                        sconto40Btn={this.state.sconto40Btn}
                                        sconto80Btn={this.state.sconto80Btn}
                                        totalStimaAfterSconti={this.state.totalStimaAfterSconti}
                                        ordineDataConsegna={this.state.ordineDataConsegna}
                                        noteOrdine={this.state.noteOrdine}
                                        handleOrdineDateChange={this.handleOrdineDateChange}
                                        handleNoteOrdineChange={this.handleNoteOrdineChange}
                                        handleSconto40={this.handleSconto40}
                                        handleSconto80={this.handleSconto80}
                                        totalQta={this.state.totalQta}
                                        applicato40={this.state.applicato40}
                                        applicato80={this.state.applicato80}
                                        avanzateBtn={this.state.avanzateBtn}
                                        sconti={this.state.sconti}
                                        toggleAvanzate={this.toggleAvanzate}
                                        handleNessuno={this.handleNessuno}
                                    />                         
                                </Col>
                            </Row> 
                        </Container>                        
                            <Container className="d-flex align-items-center" fluid>
                            <Row className="d-flex justify-content-center align-items-center" style={{ width: "100vw", margin: "0px", padding: "0px" }}>
                                <Col className="d-flex align-items-center justify-content-center" style={{width: "100%", margin: "0px", padding: "0px", paddingTop: "5px", paddingBottom: "5px", marginTop: "10px"}}>
                                    <Button type="button" className="text-center" onClick={this.toggleStimaModal} style={{width: '30%', padding: '0px', backgroundColor: "#011e41", fontSize: "20px"}}>
                                        Annulla
                                    </Button>
                                    <Button type="button" className="text-center" onClick={this.handleCompleteOrder} style={{ width: '30%', padding: '0px', backgroundColor: "#011e41", fontSize: "20px" }} disabled={this.state.disabilita}>
                                        Inserisci
                                    </Button>                              
                                </Col>
                            </Row> 
                        </Container>
                    </ModalBody>
                </Modal>
                <Modal isOpen={this.state.errorModal} toggle={this.toggleErrorModal} style={{color: "#011e41"}}>
                    <ModalBody>
                        <Container className="d-flex justify-content-center align-items-center" fluid>
                            Selezionare un'unità di misura
                        </Container>
                    </ModalBody>
                    <ModalFooter>
                        <Container className="d-flex justify-content-center align-items-center" fluid>
                            <Button className="text-center" style={{width: '50%', padding: '0px', backgroundColor: "#011e41", fontSize: "20px"}} onClick={() => this.setState({errorModal: false})}>
                                Ok
                            </Button>
                        </Container>
                    </ModalFooter>
                </Modal>
                
                <Modal isOpen={this.state.errorIndirizzo} toggle={this.toggleErrorIndirizzo} style={{color: "#011e41"}}>
                    <ModalBody>
                        <Container className="d-flex justify-content-center align-items-center" fluid>
                            Selezionare un indirizzo
                        </Container>
                    </ModalBody>
                    <ModalFooter>
                        <Container className="d-flex justify-content-center align-items-center" fluid>
                            <Button className="text-center" style={{width: '50%', padding: '0px', backgroundColor: "#011e41", fontSize: "20px"}} onClick={() => this.setState({errorIndirizzo: false})}>
                                Ok
                            </Button>
                        </Container>
                    </ModalFooter>
                </Modal>
                <Modal isOpen={this.state.finalModal} toggle={this.toggleFinalModal} style={{color: "#011e41"}}>
                    <ModalBody>
                        <Container className="d-flex justify-content-center align-items-center" fluid>
                            {this.state.cliente && this.state.cliente.posizione === "1" ?
                               "L'ordine dovrà essere verificato dall'amministrazione." :
                               "L'ordine è stato inviato con successo" }
                        </Container>
                    </ModalBody>
                    <ModalFooter>
                        <Container className="d-flex justify-content-center align-items-center" fluid>
                            <Button className="text-center" style={{ width: '50%', padding: '0px', backgroundColor: "#011e41", fontSize: "20px" }} onClick={() => this.props.history.push('/nuovoOrdine')} >
                                Ok
                            </Button>
                        </Container>
                    </ModalFooter>
                </Modal>
            </Container>
        )
    }
}
export default ContoDeposito


// WEBPACK FOOTER //
// ./src/components/NuovoOrdine/ContoDeposito.js